import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a3ec590"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "word-examples" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_it_collapse_item = _resolveComponent("it-collapse-item")!
  const _component_it_collapse = _resolveComponent("it-collapse")!

  return (_openBlock(), _createBlock(_component_it_collapse, { style: {"width":"305px","margin":"0 auto","margin-top":"20px"} }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.words, (word) => {
        return (_openBlock(), _createBlock(_component_it_collapse_item, {
          title: word.word,
          class: _normalizeClass({'no-examples': (word.examples ?? []).length === 0 }),
          key: word.id
        }, {
          default: _withCtx(() => [
            _createElementVNode("b", null, _toDisplayString(word.translation), 1),
            _createElementVNode("ul", _hoisted_1, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(word.examples, (example, index) => {
                return (_openBlock(), _createElementBlock("li", { key: index }, [
                  _createElementVNode("i", null, _toDisplayString(example.text), 1),
                  _hoisted_2,
                  _createElementVNode("span", null, _toDisplayString(example.translation), 1)
                ]))
              }), 128))
            ])
          ]),
          _: 2
        }, 1032, ["title", "class"]))
      }), 128))
    ]),
    _: 1
  }))
}